import React, { useState } from "react";

const STUDENTS = [
  {
    id: 1,
    name: "Aarav Sharma",
    class: "10th",
    section: "A",
    percentage: "96.5%",
    achievement: "District Topper",
    image: "https://images.pexels.com/photos/5212325/pexels-photo-5212325.jpeg",
    description: "Aarav is a dedicated student known for his consistency and hard work. He topped the district with excellent marks."
  },
  {
    id: 2,
    name: "Isha Mehta",
    class: "12th",
    section: "B",
    percentage: "94.2%",
    achievement: "Science Olympiad Winner",
    image: "https://images.pexels.com/photos/5212325/pexels-photo-5212325.jpeg",
    description: "Isha is passionate about science and innovation. She won the national-level Science Olympiad with her outstanding project."
  },
  {
    id: 3,
    name: "Rahul Verma",
    class: "9th",
    section: "C",
    percentage: "97.8%",
    achievement: "Math Genius Award",
    image: "https://images.pexels.com/photos/5212325/pexels-photo-5212325.jpeg",
    description: "Rahul excels in mathematics and problem-solving. He received the Math Genius Award for his brilliant performance."
  },
  {
    id: 4,
    name: "Rahul Verma",
    class: "9th",
    section: "C",
    percentage: "97.8%",
    achievement: "Math Genius Award",
    image: "https://images.pexels.com/photos/5212325/pexels-photo-5212325.jpeg",
    description: "Rahul excels in mathematics and problem-solving. He received the Math Genius Award for his brilliant performance."
  }
];


export default function TopStudentsSection() {
  const [selectedStudent, setSelectedStudent] = useState(null);

  return (
    <section className="section">
      <div className="mb-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800">Top Performing Students</h2>
        <p className="text-sm text-gray-500">Click a student to view details</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        {STUDENTS.map((student) => (
          <div
            key={student.id}
            className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 cursor-pointer"
            onClick={() => setSelectedStudent(student)}
          >
            <img
              src={student.image}
              alt={student.name}
              className="h-40 w-full object-cover"
            />
            <div className="p-4">
              <h3 className="text-lg font-semibold text-gray-800">{student.name}</h3>
              <p className="text-sm text-gray-600">Class: {student.class}</p>
              <p className="text-sm text-gray-600">Percentage: {student.percentage}</p>
            </div>
          </div>
        ))}
      </div>

{selectedStudent && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
    onClick={() => setSelectedStudent(null)} // backdrop click
  >
    <div
      className="relative w-[95%] max-w-4xl h-[85%] overflow-y-auto mx-auto bg-white rounded-lg shadow-lg flex flex-col md:flex-row"
      onClick={(e) => e.stopPropagation()} // prevent click inside popup from closing
    >
      <div className="md:w-1/2 h-64 md:h-auto">
        <img
          src={selectedStudent.image}
          alt={selectedStudent.name}
          className="h-full w-full object-cover rounded-t-lg md:rounded-l-lg md:rounded-tr-none"
        />
      </div>

      <div className="p-8 md:w-1/2 space-y-3 overflow-y-auto">
        <h3 className="text-2xl font-bold text-gray-800">{selectedStudent.name}</h3>
        <p className="text-gray-600 text-base">📚 <b>Class:</b> {selectedStudent.class}</p>
        <p className="text-gray-600 text-base">🏷️ <b>Section:</b> {selectedStudent.section}</p>
        <p className="text-gray-600 text-base">📈 <b>Percentage:</b> {selectedStudent.percentage}</p>
        <p className="text-gray-600 text-base">🏆 <b>Achievement:</b> {selectedStudent.achievement}</p>
        <p className="text-gray-600 text-base">📝 <b>Description:</b> {selectedStudent.description}</p>

        <button
          onClick={() => setSelectedStudent(null)}
          className="mt-6 inline-block bg-primary text-white px-5 py-2 rounded hover:bg-primary/90 transition"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}



    </section>
  );
}
